// @flow

import React from 'react';

export type Props = {
  progress: number,
  className: string,
};

class PreloadPage extends React.PureComponent<Props, *> {
  static defaultProps = {
    progress: 0,
    className: '',
  };

  render() {
    const { props } = this;

    const percent = Math.floor(props.progress * 100);

    return (
      <div className={`preloader ${props.className}`}>
        <div className="boundary">
          <div className="progress" style={{ width: `${percent}%` }} />
          <div className="logo" />
        </div>
      </div>
    );
  }
}

export default PreloadPage;
